import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.97776 6H17.0323L11.995 12.3L6.97776 6ZM4.21276 5.61C6.24378 8.2 9.99412 13 9.99412 13V19C9.99412 19.55 10.4466 20 10.9996 20H13.0105C13.5635 20 14.0159 19.55 14.0159 19V13C14.0159 13 17.7562 8.2 19.7872 5.61C20.3 4.95 19.8275 4 18.9929 4H5.00707C4.17254 4 3.69998 4.95 4.21276 5.61Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };
